import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaDownload } from 'react-icons/fa';
import NeuralBackground from './NeuralBackground';
import './Hero.css';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="home" className="hero">
      <NeuralBackground />
      <div className="hero-background">
        <div className="floating-shapes">
          {[...Array(6)].map((_, i) => (
            <motion.div
              key={i}
              className={`shape shape-${i + 1}`}
              animate={{
                y: [0, -20, 0],
                rotate: [0, 180, 360],
              }}
              transition={{
                duration: 6 + i,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          ))}
        </div>
      </div>

      <div className="container">
        <motion.div 
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div className="hero-text" variants={itemVariants}>
            <motion.h1 className="hero-title">
              <span className="greeting">Hi, I'm</span>
              <span className="name">Shahzaib Khan</span>
              <motion.span 
                className="role"
                animate={{ 
                  backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
                }}
                transition={{ 
                  duration: 3, 
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              >
                Cybersecurity Analyst
              </motion.span>
            </motion.h1>
            
            <motion.p className="hero-description" variants={itemVariants}>
              BS Cybersecurity Graduate passionate about ethical hacking, vulnerability assessment, Access Management
              and digital defense. Skilled in C++ and Python with a focus on solving real-world 
              security challenges through innovative thinking.
            </motion.p>

            <motion.div className="hero-buttons" variants={itemVariants}>
              <motion.a 
                href="/Shahzaib1.pdf"
                download="Shahzaib_Khan_CV.pdf"
                className="btn btn-primary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaDownload />
                Download CV
              </motion.a>
              <motion.a 
                href="#projects"
                className="btn btn-secondary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                View Projects
              </motion.a>
            </motion.div>

            <motion.div className="social-links" variants={itemVariants}>
              {[
                { icon: FaGithub, href: 'https://github.com/ShahzaibRK', label: 'GitHub' },
                { icon: FaLinkedin, href: 'https://www.linkedin.com/in/shahzaib-khan-7515522ba', label: 'LinkedIn' },
                { icon: FaEnvelope, href: 'mailto:srk161265@gmail.com', label: 'Email' }
              ].map((social, index) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target={social.href.startsWith('mailto:') ? '_self' : '_blank'}
                  rel={social.href.startsWith('mailto:') ? '' : 'noopener noreferrer'}
                  className="social-link"
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 + index * 0.1 }}
                >
                  <social.icon />
                </motion.a>
              ))}
            </motion.div>
          </motion.div>

          <motion.div className="hero-visual" variants={itemVariants}>
            <div className="profile-container">
              <motion.div 
                className="profile-image"
                animate={{ 
                  boxShadow: [
                    '0 0 20px rgba(102, 126, 234, 0.5)',
                    '0 0 40px rgba(118, 75, 162, 0.5)',
                    '0 0 20px rgba(102, 126, 234, 0.5)'
                  ]
                }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                <img 
                  src="/me.jpg" 
                  alt="Shahzaib Khan" 
                  className="profile-photo"
                />
              </motion.div>
              <div className="orbit-rings">
                {[...Array(3)].map((_, i) => (
                  <motion.div
                    key={i}
                    className={`orbit-ring ring-${i + 1}`}
                    animate={{ rotate: 360 }}
                    transition={{
                      duration: 10 + i * 5,
                      repeat: Infinity,
                      ease: "linear"
                    }}
                  />
                ))}
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;